import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './tufts-hr.css.lit';

/**
 * The Horizontal Rule component.
 * @element tufts-hr
 * @attr top-margin
 * @attr bottom-margin
 */
@customElement('tufts-hr')
export class TuftsHorizontalRule extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * top-margin can be used with spacing or Utopia
   **/
  @property({
    type: String,
    reflect: true,
    attribute: 'top-margin',
  })
  topMargin: string;

  /**
   * bottom-margin can be used with spacing or Utopia
   **/
  @property({
    type: String,
    reflect: true,
    attribute: 'bottom-margin',
  })
  bottomMargin: string;

  render(): TemplateResult {
    return html`
      ${this.addingStyleDoesHaveValue()}
      <hr />
    `;
  }

  addingStyleDoesHaveValue() {
    return this.bottomMargin || this.topMargin
      ? html`<style>
          :host {
            --hr--margin-block-start: ${this.topMargin};
            --hr--margin-block-end: ${this.bottomMargin};
          }
        </style>`
      : html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-hr': TuftsHorizontalRule;
  }
}
